/* eslint-disable camelcase -- API response is in snake_case */
import type { CustomerSnapshotAPI } from 'app/react/api/models/customer-snapshot';
import type { OrganizationSnapshotAPI } from 'app/react/api/models/organization-snapshot';

export const buildClientName = (clientSnapshot: CustomerSnapshotAPI) => {
  const { name, first_name, last_name } = clientSnapshot;

  if (name) return name;
  return `${first_name || ''} ${last_name || ''}`.trim();
};

export const buildOrganizationAddress = (organizationSnapshot: OrganizationSnapshotAPI) => {
  const { address_line_1, address_line_2, zip_code, city, country } = organizationSnapshot;

  const address = `${address_line_1}${address_line_2 ? ` ${address_line_2}` : ''}`;

  return `${address}, ${zip_code} ${city}, ${country}`;
};
